import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconCategorySmallFormat';
/** Renders an SVG icon. */
const SvgCategorySmallFormat = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2 9a3 3 0 0 1 3-3h22a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3zm3-1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1zm15 7a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1m2 4a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M10.385 13.503a.75.75 0 0 1-.064 1.059L8.13 16.5l2.19 1.939a.75.75 0 0 1-.995 1.122l-2.823-2.5a.75.75 0 0 1 0-1.123l2.823-2.5a.75.75 0 0 1 1.06.065m2.585.967a.75.75 0 0 1 1.06 0l1.5 1.5a.75.75 0 0 1 0 1.06l-1.5 1.5a.75.75 0 1 1-1.06-1.06l.97-.97-.97-.97a.75.75 0 0 1 0-1.06"
      />
      <path
        fill="currentColor"
        d="m11.604 17.646.792-.792a.5.5 0 0 0 0-.708l-.792-.792a.5.5 0 0 0-.708 0l-.792.792a.5.5 0 0 0 0 .708l.792.792a.5.5 0 0 0 .708 0"
      />
    </svg>
  );
};
SvgCategorySmallFormat.displayName = displayName;
export default SvgCategorySmallFormat;
